import { AppConfig, AuthenticationProvider, Header, Footer } from '@geit/core';
import React from 'react';
import '@geit/ui-components/dist/styles.css';
import ShopIcon from '@dls/assets/icons/Shop';
import { EVENT_MENU_CLICK, EVENT_MODAL_NAVIGATION, PREVENT_NAVIGATE_LIST } from '@/config/menu';
import navigate from '@/helpers/navigation';
import Emitter from '@/helpers/EventEmitter';
import * as actions from '@/actions';
import { useDispatch } from 'react-redux';
import { v4 as uuid } from 'uuid';
import { Cart, StyledFont } from './style';
import { TRANSFER_MOBILE_LINE, NUMBER_PORT } from '@/config/common';
import storageSession from 'redux-persist/lib/storage/session';

const iconProps = {
  size: 25,
  color: 'white'
};

const EmpowerHeader = ({ children }) => {
  const dispatch = useDispatch();

  const onMenuClick = (menu) => () => {
    if (PREVENT_NAVIGATE_LIST.includes(window.location.pathname)) {
      Emitter.emit(EVENT_MODAL_NAVIGATION, { menu });
    } else {
      navigate(menu.pathname);
      Emitter.emit(EVENT_MENU_CLICK, { nextPathName: menu.pathname });
      const orderType = menu.ordertype;
      if (orderType === TRANSFER_MOBILE_LINE) {
        dispatch(actions.resetTransferLineStore());
      }
      if (orderType === NUMBER_PORT) {
        dispatch(actions.resetNumberPortStore());
      }
      dispatch(
        actions.createNewOrder.request({
          shoppingCartType: orderType,
          cartDetails: {
            pricePlan: null
          }
        })
      );
    }
  };

  const resetSessionStorage = () => {
    storageSession.removeItem('persist:auth');
  }

  return (
    <AuthenticationProvider config={authConfig}>
      <StyledFont><Header
        additionalControl={
          <Cart>
            <a data-testid="carts" onClick={onMenuClick({ pathname: '/carts' })} key={uuid()}>
              <ShopIcon {...iconProps} />
            </a>
          </Cart>

        }
        // theme='dark'
        onApplySegment={resetSessionStorage}
        onClickLogo={resetSessionStorage}
        onClickLogout={resetSessionStorage}
        onClickMenu={resetSessionStorage}
      /></StyledFont>
      {children}
      <StyledFont>
        <Footer />
      </StyledFont>
    </AuthenticationProvider>
  );
};

export default EmpowerHeader;

// sample confiugration for MyEmpower applications
const authConfig: AppConfig = {
  app: 'empower',
  isExternal: true,
  requireApigeeToken: process.env.GATSBY_APIGEE_TOKEN_REQUIRED === 'false',
  apigeeBaseUrl: process.env.GATSBY_UDF_APIGEE_URL,
  apiBaseUrl: process.env.GATSBY_UDF_API_HOST,
  menu: process.env.GATSBY_UDF_MENU_HOST
};
// sample confiugration for Empower applications
// const authConfig: AppConfig = {
//   app: 'empower',
//   isExternal: true,
//   requireApigeeToken: process.env.REACT_APP_ENABLE_APIGEE === 'true', //enable for UAT and PROD
//   apiBaseUrl: mockServiceEnabled ? process.env.REACT_APP_API_HOST : process.env.REACT_APP_AUTH_API_HOST,
//   // refer to API Reference section for the endpoints for different environments
// };
